'use client';
var classes = {"root":"m-abbac491","item":"m-abb6bec2","itemWrapper":"m-75cd9f71","itemIcon":"m-60f83e5b"};

export default classes;
//# sourceMappingURL=List.module.mjs.map
